import contactsRoutes from "../contacts/routes"
import adminRoutes from "../admin/routes"
import timelineRoutes from '../timeline/routes'
export default [
  {
    path: '',
    name: 'CRMService',
    component: {
      template: '<div>I am the best CRM</div>'
    }
  },
  {
    path: 'timeline',
    component: () => import('../timeline'),
    children: timelineRoutes
  },
  {
    path: 'contacts',
    component: () => import('../contacts'),
    children: contactsRoutes
  },
  {
    path: 'admin',
    component: () => import('../admin'),
    children: adminRoutes
  },
]



// WEBPACK FOOTER //
// ./src/apps/crm/routes/index.js